import { QuoteItemsSearchRequestParams, QuoteItemsSearchResponse } from '@lio/api-types';
import { quoteItemQueryKey } from '@services/quoteItem/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchQuoteItems = (params: QuoteItemsSearchRequestParams | { quoteId: undefined }) => {
  const client = useClient();
  const { quoteId } = params;
  const result = useQuery<QuoteItemsSearchResponse, Error>({
    queryKey: quoteItemQueryKey.searchWithParams(params as QuoteItemsSearchRequestParams),
    queryFn: () => client(`quote/${quoteId}/quote-item`).json<QuoteItemsSearchResponse>(),
    enabled: !!quoteId,
    staleTime: 20000,
  });
  return { ...result, quoteItems: result.data };
};
